export default {
  setTestFilter(state, filterData) {
    state.filterForPreTestReserving = filterData;
  },
  setFilter(state, filterData) {
    state.filterForPreReserving = filterData;
  },
  setReplacedSessionData(state, sessionData) {
    state.replacedSessionData = sessionData;
  },
  removeTestFilter(state) {
    delete state.filterForPreTestReserving;
  },
  removeFilter(state) {
    delete state.filterForPreReserving;
  },
  removeReplacedSessionData(state) {
    delete state.replacedSessionData;
  },
};
